import { createResourceReducer, typedResourceService } from './resourceReducer'

const { reducer, actions, thunks } = createResourceReducer({
    sliceName: 'codenotebooks',
    label: 'Code Notebook',
    labelPlural: 'Code Notebooks',
    service: typedResourceService('CodeNotebook'),
})

export const { appendResource: appendCodeNotebook, destroyResource: destroyCodeNotebook, changeResource: changeCodeNotebook } = actions
export const { createResource: createCodeNotebook, initializeResources: initializeCodeNotebooks, deleteResource: deleteCodeNotebook, updateResource: updateCodeNotebook, searchResources: searchCodeNotebooks, refreshResource: refreshCodeNotebook } = thunks

export default reducer
